import React from 'react'

const Brakes = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={19.844}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M231.124 365.376c-59.593 0-108.075-48.481-108.075-108.072s48.482-108.072 108.075-108.072c59.59 0 108.069 48.481 108.069 108.072s-48.479 108.072-108.069 108.072z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={19.844}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M231.123 299.448c-23.239 0-42.145-18.906-42.145-42.145s18.906-42.144 42.145-42.144c23.238 0 42.143 18.905 42.143 42.144s-18.906 42.145-42.143 42.145z"
    />
    <ellipse fill={color} cx={230.345} cy={184.42} rx={9.252} ry={9.256} />
    <path
      fill={color}
      d="M159.74 245.026a9.19 9.19 0 0 1-6.544-2.708c-3.61-3.61-3.61-9.486 0-13.096a9.19 9.19 0 0 1 6.544-2.708 9.19 9.19 0 0 1 6.544 2.708c3.61 3.61 3.61 9.486 0 13.096a9.196 9.196 0 0 1-6.544 2.708zM304.159 245.026a9.19 9.19 0 0 1-6.544-2.708c-3.611-3.61-3.611-9.486 0-13.096 1.747-1.747 4.07-2.708 6.544-2.708s4.797.961 6.544 2.708c3.61 3.61 3.61 9.486 0 13.096a9.195 9.195 0 0 1-6.544 2.708zM275.275 328.468a9.19 9.19 0 0 1-6.544-2.708c-3.61-3.61-3.61-9.486 0-13.096a9.19 9.19 0 0 1 6.544-2.708 9.19 9.19 0 0 1 6.544 2.708c3.611 3.611 3.611 9.486 0 13.096a9.19 9.19 0 0 1-6.544 2.708zM191.833 328.468a9.19 9.19 0 0 1-6.544-2.708c-3.61-3.61-3.61-9.486 0-13.096a9.19 9.19 0 0 1 6.544-2.708 9.19 9.19 0 0 1 6.544 2.708c3.61 3.611 3.61 9.486 0 13.096a9.19 9.19 0 0 1-6.544 2.708z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={19.844}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M376.076 333.572c.068-11.355 4.056-21.322 4.056-21.322s4.795-11.923 7.025-32.232h11.628c12.893 0 23.441-10.548 23.441-23.441 0-12.893-10.549-23.441-23.441-23.441h-12.261c-1.505-11.57-4.083-24.073-8.25-37.359 0 0-1.644-7.186-2.085-12.453h-10.743c-6.643 0-11.346 5.128-12.078 12.078 13.186 49.455 12.453 84.617 0 129.676 0 4.77 5.435 12.078 12.078 12.078h10.975c-.091-1.202-.352-2.356-.345-3.584z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={19.844}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M376.076 333.572c.068-11.355 4.056-21.322 4.056-21.322s4.795-11.923 7.025-32.232h11.628c12.893 0 23.441-10.548 23.441-23.441 0-12.893-10.549-23.441-23.441-23.441h-12.261c-1.505-11.57-4.083-24.073-8.25-37.359 0 0-2.198-9.585-2.198-14.729 0-14.912 7.25-28.125 18.412-36.325-37.118-53.772-98.048-85.834-163.362-85.834-109.409 0-198.42 89.009-198.42 198.415 0 109.407 89.011 198.416 198.42 198.416 65.296 0 126.219-32.053 163.339-85.808-11.202-8.199-18.479-21.419-18.389-36.34z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth={19.844}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M467.337 180.082l-2.152-8.363c-4.3-20.399-22.379-35.721-44.058-35.721-24.881 0-45.051 20.17-45.051 45.051 0 5.144 2.198 14.729 2.198 14.729 4.167 13.287 6.745 25.789 8.25 37.359h12.261c12.893 0 23.441 10.549 23.441 23.441 0 12.893-10.549 23.441-23.441 23.441h-11.628c-2.23 20.309-7.025 32.232-7.025 32.232s-3.987 9.967-4.056 21.322c-.15 24.88 20.17 45.051 45.051 45.051 20.496 0 37.599-13.773 43.059-32.505l1.264-3.461c25.084-83.511 1.887-162.576 1.887-162.576z"
    />
  </svg>
)
export default Brakes
